export const isValidDate = (value: string | number | Date | null | undefined): value is Date => {
  if (value === undefined || value === null) {
    return false;
  }
  return !Number.isNaN(new Date(value).getTime());
};

export const dateToString = (date: Date | string | null | undefined): string => {
  if (!date) {
    return new Date().toISOString();
  }
  
  if (typeof date === 'string') {
    return date;
  }
  
  if (date instanceof Date) {
    return date.toISOString();
  }
  
  return new Date().toISOString();
};
